"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.choose_fmt = exports.getConditionFormat = exports.getFullFormatList = exports.checkConditon = exports.splitFormat = void 0;
/**
 * 将原始格式字符串以 ';' 分割, 返回格式字符串数组
 * @param foramt 输入 format 字符串
 */
function splitFormat(format) {
    var outputList = [];
    var quotationFlag = false;
    var lastSplitIndex = 0;
    for (var currentIndex = 0; currentIndex < format.length; currentIndex++) {
        switch (format.charCodeAt(currentIndex)) {
            case 34: // 符号 "
                quotationFlag = !quotationFlag;
                break;
            case 95: // 符号 _
            case 92: // 符号 \\
            case 42: // 符号 *
                if (!quotationFlag) {
                    currentIndex += 1;
                }
                break;
            case 59: // 符号 ;
                // 引号内的 ; 不做分割
                if (!quotationFlag) {
                    // 将新的格式串添加入数组
                    outputList.push(format.substr(lastSplitIndex, currentIndex - lastSplitIndex));
                    lastSplitIndex = currentIndex + 1;
                }
                break;
            default:
                break;
        }
    }
    // 双引号未闭合则报错
    if (quotationFlag === true) {
        throw new Error("Format |" + format + "| unterminated string ");
    }
    outputList.push(format.substr(lastSplitIndex));
    return outputList;
}
exports.splitFormat = splitFormat;
/**
 * 判断实际输入值是否满足格式串对应的条件规则
 * 例如给定格式 [>=1000] 以及输入值 123 将会认为条件格式不成立
 * @param value 用户输入
 * @param regExpResult 正则匹配结果
 */
function checkConditon(value, regExpResult) {
    // 规则表
    var checkMap = {
        '+': function () { return !!regExpResult[1].match(/>|>=|<>/); },
        '0': function () { return !!regExpResult[1].match(/<=|>=|=/); },
        '-': function () { return !!regExpResult[1].match(/<|<=|<>/); },
    };
    var thresh = parseFloat(regExpResult[2]);
    var compareReference = value - thresh;
    var compareSign;
    // 根据检查值二者之差选择对应的符号
    if (compareReference > 0) {
        compareSign = '+';
    }
    else if (compareReference < 0) {
        compareSign = '-';
    }
    else {
        compareSign = '0';
    }
    // 利用规则表判断是否满足条件
    return checkMap[compareSign]();
}
exports.checkConditon = checkConditon;
/**
 * 根据当前格式串组个数补全成 4 种格式的标准行为
 * @param formatList 得到的格式串数组
 * @param isLastFormatText 格式串数组最后一个是否为文本格式
 */
function getFullFormatList(formatList, isLastFormatText) {
    var resultList;
    switch (formatList.length) {
        case 1:
            resultList = isLastFormatText
                ? [formatList[0], formatList[0], formatList[0], formatList[0]]
                : [formatList[0], formatList[0], formatList[0], '@'];
            break;
        case 2:
            resultList = isLastFormatText
                ? [formatList[0], formatList[0], formatList[0], formatList[1]]
                : [formatList[0], formatList[1], formatList[0], '@'];
            break;
        case 3:
            resultList = isLastFormatText
                ? [formatList[0], formatList[1], formatList[0], formatList[2]]
                : [formatList[0], formatList[1], formatList[2], '@'];
            break;
        default:
            resultList = formatList;
            break;
    }
    return resultList;
}
exports.getFullFormatList = getFullFormatList;
/**
 * 判断并获取条件格式
 * @param value 输入值
 * @param formatList 格式串分割补齐后的数组
 */
function getConditionFormat(value, formatList) {
    // 条件格式正则匹配字符串
    var conditionMarkRegExp = /\[[=<>]/;
    var conditionExpressionRegExp = /\[(=|>|>=|<|<=|<>)(-?\d+(?:\.\d*)?)\]/;
    var conditionExpressionRegExpWithNegativeInfinity = /\[(=|>|>=|<|<=|<>)(-Infinity)\]/;
    // 记录是否成功匹配
    var isMatchedConditionalMark = false;
    // 只保留前两个, 正数和负数
    var subFormatList = formatList.slice(0, 2);
    // 正数 - 存在 [] 但没有条件符号, 需要补上默认的 > 0
    if ((subFormatList[0].indexOf('[]') !== -1 && !subFormatList[0].match(conditionMarkRegExp))) {
        subFormatList[0] = "[>0]" + subFormatList[0];
    }
    // 负数 - 存在 [] 但没有条件符号, 需要补上默认的 > -Infinity
    if ((subFormatList[1].indexOf('[]') !== -1 && !subFormatList[1].match(conditionMarkRegExp))) {
        subFormatList[1] = "[>" + Number.NEGATIVE_INFINITY + "]" + subFormatList[1];
    }
    // 记录条件格式匹配成功的次数
    var matchedSuccessTimes = 0;
    for (var _i = 0, subFormatList_1 = subFormatList; _i < subFormatList_1.length; _i++) {
        var format = subFormatList_1[_i];
        // 判断是否存在条件符号 = >= <= < >
        if (!!format.match(conditionMarkRegExp)) {
            // 若命中条件表达式更新记录变量
            isMatchedConditionalMark = true;
            // 匹配完整的条件表达式
            var matchResult = format.match(conditionExpressionRegExp)
                || format.match(conditionExpressionRegExpWithNegativeInfinity);
            // 判断是否满足
            if (!!matchResult) {
                matchedSuccessTimes += 1;
            }
            else {
                continue;
            }
            // 判断条件表达式是否满足
            if (checkConditon(value, matchResult)) {
                return format;
            }
        }
    }
    // 两个条件表达式判断均失败, 但存在条件符号
    if (isMatchedConditionalMark) {
        // TODO: 逻辑问题, 在都未匹配上时应该展示什么格式? 后期增加自定义时处理
        // =2, 表示有条件格式, 但是前2条都无法命中
        return matchedSuccessTimes === 2 ? formatList[2] : subFormatList[1];
    }
    return null;
}
exports.getConditionFormat = getConditionFormat;
/**
 * 根据用户的输入以及格式串, 选择对应的格式 (参考文档中格式串选择规则)
 * TODO: 函数名称向外暴露, 后期修改
 * @param originFormat 原始格式
 * @param value 用户输入
 */
function choose_fmt(originFormat, value) {
    var formatList;
    var numericalVal = Number(value);
    // 分割格式串
    try {
        formatList = splitFormat(originFormat);
    }
    catch (error) {
        // 分割格式串异常直接默认为常规格式
        formatList = ['General'];
    }
    var formatLength = formatList.length;
    // 判断分割后 format 数组最后一个类型是否为文本
    var isLastFormatText = formatList[formatLength - 1].indexOf('@') > -1;
    // 默认排除文本作判断
    if (formatLength < 4 && isLastFormatText) {
        formatLength -= 1;
    }
    // 补全格式串数组
    formatList = getFullFormatList(formatList, isLastFormatText);
    // 输入非数字直接返回文本格式
    if (isNaN(numericalVal)) {
        return {
            formatListLength: formatLength,
            chosenFormatCode: formatList[3],
        };
    }
    var finalFormat;
    // 若为数字则根据正负选择对应的格式
    if (numericalVal === 0) {
        finalFormat = formatList[2];
    }
    else {
        finalFormat = numericalVal > 0 ? formatList[0] : formatList[1];
    }
    // 不包含 [] 确保不包含条件格式, 可直接返回
    if (formatList[0].indexOf('[') === -1 && formatList[1].indexOf('[') === -1) {
        return {
            formatListLength: formatLength,
            chosenFormatCode: finalFormat,
        };
    }
    // 判断原始格式中包含条件格式, 目前暂不支持条件格式
    var conditionFormat = getConditionFormat(numericalVal, formatList);
    if (!!conditionFormat) {
        return {
            formatListLength: formatLength,
            chosenFormatCode: conditionFormat,
        };
    }
    // 其余情况同样直接返回
    return {
        formatListLength: formatLength,
        chosenFormatCode: finalFormat,
    };
}
exports.choose_fmt = choose_fmt;
//# sourceMappingURL=format-code-utils.js.map